// extracted by mini-css-extract-plugin
export default {"addressSection":"DV-z","disabled":"EV-z","sectionButtons":"FV-z","logo":"GV-z"};